import "../footer-modal.scss";
import "../../../../scss/common.scss";


const TermsAndCondition = () => {
  return (
    <>
      <div className="modalContent">
        <h2 className="fs-22 label-color">General</h2>
        <p className="label-color fs-18">
          This website is owned and operated by DriverTok Ltd (Company number
          12125945), whose registered office is in England. For the purposes of
          these Terms and Conditions: “We”, “Our” and “Us” refers to DriverTok
          Limited while references to “You” and “Your” refers to the persons
          accessing this website (including persons who access this site on the
          behalf of other persons); references to “Material” or “Materials”
          includes data, information, and databases.
        </p>
        <p className="label-color fs-18">
          Please review these Terms and Conditions carefully before using this
          website. Your use of this website indicates Your agreement to be bound
          by these Terms and Conditions in consideration of the access provided
          to the website as detailed below. If You do not agree to these Terms
          and Conditions, any of the related documentation linked below, or
          other restrictions notified to You during Your use of this website You
          are not permitted to and agree not to, use or access this website.
        </p>
        <h2 className="fs-22 label-color">Scope of these Terms and Conditions</h2>
        <p className="label-color fs-18">
          These Terms and Conditions refer only to Your use of this website (Pay
          PCN ) and unless separate or additional terms apply, any application
          using content from this website and any mini-site on this website.
          Separate terms and conditions shall apply to paying a PCN, appealing a
          PCN, car parking, or other services that we may provide, or any other
          promotion which We may run from time to time.
        </p>
        <h2 className="fs-22 label-color">Data protection</h2>
        <p className="label-color fs-18">
          Any personal information You supply to Us when You use this website
          will be used in accordance with Our Data Protection Policy and/or Our
          Privacy Policy and Cookies Policy. During the Account creation
          process, you might be required to select a password (“Login
          Information”). You shall not share the Account or the Login
          Information, nor let anyone else access your Account or do anything
          else that might jeopardize the security of your Account. In the event
          you become aware of or reasonably suspect any breach of security,
          including without limitation any loss, theft, or unauthorized
          disclosure of the Login Information, you must immediately notify
          DriverTok and modify your Login Information. You are solely
          responsible for maintaining the confidentiality of the Login
          Information, and you will be responsible for all uses of the Login
          Information, including purchases, whether or not authorized by you.
          You are responsible for anything that happens through your Account.
          DriverTok reserves the right to remove or reclaim any usernames at any
          time and for any reason, including but not limited to claims by a
          third party that a username violates the third party’s rights.
        </p>
        <h2 className="fs-22 label-color">Proprietary Rights</h2>
        <p className="label-color fs-18">
          All Materials on this website, the appearance, organization, and
          layout of this website, the underlying software code, and the
          underlying data are subject to trademarks, copyright, database rights,
          and other registered and unregistered intellectual property rights
          which are owned either directly by Us or by Our licensors. Unless
          otherwise authorized within these Terms and Conditions, you must not
          copy, modify, alter, publish, broadcast, distribute, sell or transfer
          (whether in whole or in part) any Material on this website or the
          underlying software code or underlying data.
        </p>
        <h2 className="fs-22 label-color">Permitted users of this website</h2>
        <p className="label-color fs-18">
          Subject to your agreement and continuing compliance with these Terms
          of Service and any other relevant DriverTok policies, DriverTok grants
          you a non-exclusive, non-transferable, non-sublicensable, revocable
          limited license subject to the limitations below to access and use the
          Service for your own non-commercial purposes. You agree not to use the
          Service for any other purpose. The following restrictions apply to the
          use of the Service: You shall not create an Account or access the
          Service if you are under the age of 13; You shall restrict use by
          minors, and you will deny access to children under the age of 13. You
          accept full responsibility for any unauthorized use of the Service by
          minors. You are responsible for any use of your credit card or another
          payment instrument (e.g. Paypal) by minors. You shall not sell, rent
          or give away your Account, create an Account using a false identity or
          information, or on behalf of someone other than yourself; You shall
          not use the Service if you have previously been removed by DriverTok,
          or previously been banned from using any DriverTok app; You shall use
          your Account only for non-commercial purposes; You shall not use the
          Service to advertise, solicit, or transmit any commercial
          advertisements, including chain letters, junk or spam e-mail, or
          repetitive messages to anyone;
        </p>
        <p className="label-color fs-18">
          Your use of this website is personal to You. We provide this website
          solely to permit You to view Our locations and to view the
          availability of Our goods and services and (where applicable) to
          transact business with Us and for no other purpose. You are
          responsible for maintaining the confidentiality of Your website access
          information.
        </p>
        <p className="label-color fs-18">
          You may choose to permit family members, friends, or colleagues to
          access the website on Your behalf by providing website access
          information and/or booking data to such persons provided that: You
          have obtained the consent of any other persons who are booking data or
          personal data is accessible with Your data (such as a group booking);
          and
        </p>
        <p className="label-color fs-18">
          You accept full responsibility for the acts and omissions of that
          person when accessing the website using the website access information
          and/or booking data provided by you whether such access is authorized
          by You or not. You must not permit access to or use of this website or
          any of the Material on or obtained from this website to any commercial
          entity or other organization providing a service to the public.
        </p>
        <h2 className="fs-22 label-color">Security</h2>
        <p className="label-color fs-18">
          If You have reason to believe that Your access to the website is no
          longer secure (e.g. loss, theft or unauthorized disclosure, or use of
          user names, passwords, and personal identification numbers), You must
          promptly change the affected access information.
        </p>
        <h2 className="fs-22 label-color">License</h2>
        <p className="label-color fs-18">
          You hereby grant to DriverTok an irrevocable, perpetual, transferable,
          fully paid-up, royalty-free, worldwide license (including the right to
          sublicense and assign to a third party) and right to copy, reproduce,
          fix, adapt, modify, create derivative works from, manufacture,
          commercialize, publish, distribute, sell, license, sublicense,
          transfer, lease, transmit, publicly display, publicly perform, or
          provide access to electronically, broadcast, communicate to the public
          by telecommunication, display, perform, enter into computer memory,
          and use and practice, in any way, your User Content as well as all
          modified and derivative works thereof in connection with our provision
          of the Service, including marketing and promotions of the Service. You
          also hereby grant to DriverTok the right to authorize others to
          exercise any of the rights granted to DriverTok under these Terms of
          Service. You further hereby grant to DriverTok the unconditional,
          irrevocable right to use and exploit your name, likeness, and any
          other information or material included in any User Content and in
          connection with any User Content, without any obligation to you.
          Except as prohibited by law, you waive any rights of attribution
          and/or any moral rights you may have in your User Content, regardless
          of whether your User Content is altered or changed in any manner.
          DriverTok does not claim any ownership rights in your User Content and
          nothing in these Terms of Service is intended to restrict any rights
          that you may have to use and exploit your User Content. DriverTok has
          no obligation to monitor or enforce your intellectual property rights
          in or to your User Content.
        </p>
        <h2 className="fs-22 label-color">Appropriate use</h2>
        <p className="label-color fs-18">
          Your access to this website is on a temporary basis, and we reserve
          the right to withdraw, restrict or amend the services accessibly to
          You on the website without notice at our absolute discretion. You may
          only use this website in accordance with these Terms and Conditions
          and, in any event, for lawful and proper purposes which includes
          complying with all applicable laws, regulations, and codes of practice
          within the UK or other jurisdiction from which You are accessing this
          website. Except as expressly permitted by Us, You shall not use this
          website for any purpose. In particular, You agree that You must not:
        </p>
        <ul>
          <li className="label-color fs-18">
            Post, transmit, or disseminate any information on or via this
            website that is or may be harmful, obscene, defamatory, or otherwise
            illegal;
          </li>
          <li className="label-color fs-18">
            Use this website in a manner that causes or may cause an
            infringement of the rights of any other person or party.
          </li>
          <li className="label-color fs-18">
            Use any software, routine, or device to interfere or attempt to
            interfere electronically or manually with the operation or
            functionality of this website including but not limited to Website
            Terms and Conditions uploading or making available files containing
            corrupt data or viruses via whatever means.
           <span className="label-color fs-18"> Deface, alter or interfere with the front end ‘look and feel of this
            website or the underlying software code.</span>
          </li>
          <li className="label-color fs-18">
            Take any action that imposes an unreasonable or disproportionately
            large load on this website or related infrastructure.
          </li>
          <li className="label-color fs-18">
            Permit any automatic registration, logging in, or access to any of
            the Material on the website; • obtain or attempt to obtain
            unauthorized access, via whatever means, to any of Our networks or
            accounts or to information about other users; and
          </li>
          <li className="label-color fs-18">
            Disclose confidential information of any person or entity including,
            without limitation, Our confidential information.
          </li>
        </ul>
        <h2 className="fs-22 label-color">Remedies for breach of these Terms and Conditions</h2>
        <p className="label-color fs-18">
          Without prejudice to any of Our other rights (whether at law or
          otherwise), We reserve the right to: Cancel Your Account and purchases
          without reference to You; and/or;
        </p>
        <p className="label-color fs-18">
          Deny Your access to this website and block your access to the website
          where We believe (in Our absolute discretion) that You (or persons who
          access this site on your behalf using website access information
          and/or booking data that You have provided to them) are in breach of
          any of these Terms and Conditions.
        </p>
        <h2 className="fs-22 label-color">Changes to this website</h2>
        <p className="label-color fs-18">
          We may make improvements or changes to the information, services,
          products, and other Materials on this website, or terminate this
          website, at any time without notice. We may also modify these Terms
          and Conditions at any time, and such modification shall be effective
          immediately upon posting of the modified Terms and Conditions on this
          website. Accordingly, your continued access or use of this website is
          deemed to be Your acceptance of the modified Terms and Conditions.
        </p>
        <h2 className="fs-22 label-color">Links to other websites</h2>
        <p className="label-color fs-18">
          This website may include links to other internet sites. We do not
          endorse any such websites and We are not responsible for the
          information, Material, products, or services contained on or
          accessible through those websites. Your access and use of such
          websites remain solely at Your own risk. You may only link to this
          website with Our express written permission. We expressly reserve the
          right to withdraw Our consent at any time to a link which in Our sole
          opinion is inappropriate or controversial.
        </p>
        <h2 className="fs-22 label-color">Limitation of liability</h2>
        <p className="label-color fs-18">
          In no event will We be liable for any direct, indirect, special,
          punitive, exemplary or consequential losses or damages of whatsoever
          kind arising out of access to, or the use of this website or any
          information contained in it, including loss of profit and the like
          whether or not in the contemplation of the parties, whether based on
          breach of contract, tort (including negligence), product liability or
          otherwise, even if advised of the possibility of such damages. Nothing
          in these Terms and Conditions shall exclude or limit Our liability for
          death or personal injury caused by negligence or for fraud and
          fraudulent misrepresentation. All software products downloaded from
          any section of this website or via a link pointed to by this website
          are downloaded, installed, and used totally and entirely at the user’s
          own risk.
        </p>
        <h2 className="fs-22 label-color">Disclaimer of warranty</h2>
        <p className="label-color fs-18">
          To the maximum extent permitted by law, We disclaim all implied
          warranties with regard to the information, services and Materials
          contained on this website. All such information, services, and
          Materials are provided “as is” and “as available” without warranty of
          any kind. We make no warranty whatsoever for the reliability,
          stability or any virus-free nature of any software being downloaded
          from this website, nor for the availability of the download sites
          where applicable.
        </p>
        <h2 className="fs-22 label-color">Indemnification</h2>
        <p className="label-color fs-18">
          You agree to indemnify, defend and hold Us harmless from any
          liability, loss, claim, and expense (including reasonable legal fees)
          related to Your breach of these Terms and Conditions (including, but
          not limited to, any breach by persons acting on your behalf who access
          this site using website access information and/or booking/purchase
          data that You have provided to them).
        </p>
        <h2 className="fs-22 label-color">Purchases</h2>
        <p className="label-color fs-18">
          In the Service, you may purchase, with “real world” money, a limited,
          personal, non-transferable, non-sublicensable, revocable license to
          use DriverTok Serice and information by product purchased. DriverTok
          may manage, regulate, control, modify or eliminate the product and
          information, with or without notice. DriverTok shall have no liability
          to you or any third party in the event that DriverTok exercises any
          such rights.
        </p>
        <h2 className="fs-22 label-color">Payment of Fees</h2>
        <p className="label-color fs-18">
          You agree to pay all fees and applicable taxes incurred by you or
          anyone using an Account registered to you. DriverTok may revise the
          pricing for the goods and services offered through the Service at any
          time. YOU ACKNOWLEDGE THAT DRIVERTOK IS NOT REQUIRED TO PROVIDE A REFUND
          FOR ANY REASON AND THAT YOU WILL NOT RECEIVE MONEY OR OTHER
          COMPENSATION FOR UNUSED SUBSCRIPTIONS OR PRODUCTS WHEN AN ACCOUNT IS
          CLOSED, WHETHER SUCH CLOSURE WAS VOLUNTARY OR INVOLUNTARY.
        </p>
        <h2 className="fs-22 label-color">Updates to the Service</h2>
        <p className="label-color fs-18">
          You understand that the Service is an evolving one. DriverTok may
          require that you accept updates to the Service and to DriverTok’s apps
          you have installed on your computer. You acknowledge and agree that
          DriverTok may update the Service and DriverTok apps, with or without
          notifying you. You may need to update third-party software from time
          to time in order to receive the Service and use DriverTok’s Apps.
        </p>
        <h2 className="fs-22 label-color">Assignment</h2>
        <p className="label-color fs-18">
          DriverTok may assign or delegate these Terms of Service and/or the
          DriverTok Privacy Policy, in whole or in part, to any person or entity
          at any time with or without your consent. You may not assign or
          delegate any rights or obligations under the Terms of Service or
          Privacy Policy without DriverTok’s prior written consent, and any
          unauthorized assignment and delegation by you is ineffective.
        </p>
        <h2 className="fs-22 label-color">Supplemental Policies</h2>
        <p className="label-color fs-18">
          DriverTok may publish additional policies related to specific services
          such as forums, contests, or loyalty programs. Your right to use such
          services is subject to those specific policies and these Terms of
          Service.
        </p>
        <h2 className="fs-22 label-color">Entire Agreement</h2>
        <p className="label-color fs-18">
          these Terms of Service, any Supplemental Policies, and any documents
          expressly incorporated by reference herein (including the DriverTok
          Privacy Policy), contain the entire understanding of you and
          DriverTok, and supersede all prior understandings of the parties
          hereto relating to the subject matter hereof, whether electronic, oral
          or written, or whether established by custom, practice, policy or
          precedent, between you and us with respect to the Service.
        </p>
        <h2 className="fs-22 label-color">No Waiver</h2>
        <p className="label-color fs-18">
          The failure of DriverTok to require or enforce strict performance by
          you of any provision of these Terms of Service or the DriverTok
          Privacy Policy or failure to exercise any right under them shall not
          be construed as a waiver or relinquishment of DriverTok’s right to
          assert or rely upon any such provision or right in that or any other
          instance. The express waiver by DriverTok of any provision, condition,
          or requirement of these Terms of Service or the DriverTok Privacy
          Policy shall not constitute a waiver of any future obligation to
          comply with such provision, condition or requirement. Except as
          expressly and specifically set forth in this these Terms of Service,
          no representations, statements, consents, waivers, or other acts or
          omissions by DriverTok shall be deemed a modification of these Terms
          of Service nor legally binding, unless documented in physical writing,
          hand signed by You and a duly appointed officer of DriverTok.
        </p>
        <h2 className="fs-22 label-color">Miscellaneous</h2>
        <p className="label-color fs-18">
          These Terms and Conditions contain all the terms of Your agreement
          with Us relating to Your use of this website. No other written or oral
          statement (including statements in any brochure or promotional
          literature published by Us) will be incorporated. Any failure to
          assert any rights We may have under these Terms and Conditions does
          not constitute a waiver of Our right to assert the same or any other
          right at any other time or against any other person. If any provision
          of this Agreement is found to be invalid or unenforceable, then the
          invalid or unenforceable provision will be removed from these Terms
          and Conditions without affecting the validity or enforceability of any
          other provision. Throughout this website, the terms “partner(s)” and
          “partnership(s)” are used to refer to individual marketing or
          cooperation agreements and not to any relationship which has specific
          legal or tax implications. We do not, therefore, accept any liability
          for the conduct of these partner organizations. Throughout this
          website, the term “person(s)” is used to refer to natural and legal
          persons.
        </p>
        <h2 className="fs-22 label-color">Applicable Law, Language, and Jurisdiction</h2>
        <p className="label-color fs-18">
          Your use of this website, any Material accessed or downloaded from it
          and the operation of these Terms and Conditions, and any dispute or
          claim arising out of or in connection with such matters, their subject
          matter or formation (including but not limited to non-contractual
          disputes or claims) shall be governed by, construed and interpreted in
          accordance with the laws of England and Wales and You agree to submit
          to the nonexclusive jurisdiction of the English Courts. We reserve the
          right to bring proceedings in:
        </p>
        <ul>
          <li className="label-color fs-18">The Courts of the country of Your residence;</li>
          <li className="label-color fs-18">
            The Courts of the location of Your access, use, or storage of any
            Materials obtained from the website;
          </li>
          <li className="label-color fs-18">
            The Courts of the location of any breach by You of these Terms and
            Conditions; and/or; and
          </li>
          <li className="label-color fs-18">
            The Courts of the location of your authorization of any of the above
            acts. You acknowledge and agree that damages alone would not be an
            adequate remedy for any breach of the terms of these Terms and
            Conditions.
          </li>
          <li className="label-color fs-18">
            Accordingly, We shall be entitled to the remedies of injunction,
            specific performance or other equitable relief for any threatened or
            actual breach of the terms of these Terms and Conditions.
          </li>
        </ul>
      </div>
    </>
  );
};

export default TermsAndCondition;
